














































































































import Vue from 'vue'

import CTA from '@/component/common/CTA.vue'

import { v5 as uuidv5 } from 'uuid'

export default Vue.extend({
  name: 'Contact',
  components: {
    CTA
  },
  data() {
    return {
      firstname: '',
      surname: '',
      phone: '',
      email: '',
      profile: '',

      store: {
        initial: true,
        success: false,
        error: false,

        canCommit: true,

        hasError: {
          firstname: false,
          surname: false,
          email: false,
          emailInvalid: false
        }
      }
    }
  },
  methods: {
    isvalid(): any {
      if (!this.firstname) {
        this.store.hasError.firstname = true
        return false
      }

      if (!this.surname) {
        this.store.hasError.surname = true
        return false
      }

      if (!this.email) {
        this.store.hasError.email = true
        return false
      }
      if (!this.validMail(this.email)) {
        this.store.hasError.emailInvalid = true
        return false
      }

      return true
    },

    setCommit(): any {
      this.store.initial = true

      this.store.hasError.firstname = false
      this.store.hasError.surname = false
      this.store.hasError.email = false
      this.store.hasError.emailInvalid = false

      this.store.success = false
      this.store.error = false
    },

    validMail(mail: string): any {
      const expression = /\S+@\S+\.\S+/
      return expression.test(mail)
    },

    submit() {
      this.setCommit()

      if (this.isvalid()) {
        const data = new FormData()
        data.append('email', this.email)
        data.append('uuid', uuidv5(this.email, uuidv5.DNS))
        data.append('firstname', this.firstname)
        data.append('surname', this.surname)
        data.append('phone', this.phone)
        data.append('profile', this.profile)

        fetch('https://script.google.com/macros/s/AKfycbxIVm2qQ-adKm8sRW8xnqpOHJXvWqRGPyu66NB57nyk5SeJl9I/exec', {
          method: 'POST',
          body: data
        }).then((data) => {
          // console.log('success', data)
          this.store.initial = false
          this.store.success = true
        }).catch((error) => {
          this.store.initial = false
          this.store.error = true
        })
      }

      // const cio_ = new CIO(process.env.VUE_APP_CIO_SECRET, process.env.VUE_APP_CIO_UUID)
      // cio_.identify(uuidv5('thomas.janhonen@thriv.dev', uuidv5.DNS), {
      //   email: 'thomas.janhonen@thriv.dev',
      //   created_at: '1577883600',

      //   firstname: 'thomas',
      //   surname: 'janhonen',
      //   phone: '+358 50 526 7614'
      // })
    }
  }
})
